import React from 'react';
import { getCommonStyles } from '../styles/commonStyles';

interface ActionButtonsProps {
  isDarkTheme?: boolean;
  onCancel: () => void;
  onSave: () => void;
  onSubmit: () => void;
  saveLoading?: boolean;
  submitLoading?: boolean;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
  isDarkTheme,
  onCancel,
  onSave,
  onSubmit,
  saveLoading = false,
  submitLoading = false
}) => {
  const commonStyles = getCommonStyles(isDarkTheme || false);

  return (
    <div style={{ marginTop: "20px", display: "flex", gap: "10px" }}>
      <button
        style={commonStyles.button}
        onClick={onCancel}
      >
        Cancel
      </button>
      <button
        style={{
          ...commonStyles.button,
          opacity: saveLoading ? 0.7 : 1,
          cursor: saveLoading ? 'not-allowed' : 'pointer'
        }}
        onClick={onSave}
        disabled={saveLoading}
      >
        {saveLoading ? (
          <>
            <style>
              {`
                @keyframes spin {
                  0% { transform: rotate(0deg); }
                  100% { transform: rotate(360deg); }
                }
              `}
            </style>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <div
                style={{
                  width: "16px",
                  height: "16px",
                  border: "2px solid #f3f3f3",
                  borderTop: "2px solid #007bff",
                  borderRadius: "50%",
                  animation: "spin 1s linear infinite"
                }}
              />
              Saving...
            </div>
          </>
        ) : (
          'Save'
        )}
      </button>
      <button
        style={{
          ...commonStyles.button,
          opacity: submitLoading ? 0.7 : 1,
          cursor: submitLoading ? 'not-allowed' : 'pointer'
        }}
        onClick={onSubmit}
        disabled={submitLoading}
      >
        {submitLoading ? (
          <>
            <style>
              {`
                @keyframes spin {
                  0% { transform: rotate(0deg); }
                  100% { transform: rotate(360deg); }
                }
              `}
            </style>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <div
                style={{
                  width: "16px",
                  height: "16px",
                  border: "2px solid #f3f3f3",
                  borderTop: "2px solid #007bff",
                  borderRadius: "50%",
                  animation: "spin 1s linear infinite"
                }}
              />
              Submitting...
            </div>
          </>
        ) : (
          'Submit'
        )}
      </button>
    </div>
  );
};

export default ActionButtons;